export const transformPhoneNumber = (phoneNumber: string): string => {
  // Remove any non-digit character from the phone number except the plus sign at the beginning
  const cleanedUpPhoneNumber = phoneNumber.replace(/[^\d+]/g, '').replace(/^\+/, '');

  if (cleanedUpPhoneNumber.startsWith('1') && cleanedUpPhoneNumber.length === 11) {
    // Already has country code
    return `+${cleanedUpPhoneNumber}`;
  } else if (cleanedUpPhoneNumber.length === 10) {
    // Add US country code for 10-digit numbers
    return `+1${cleanedUpPhoneNumber}`;
  } else {
    // For any other case, ensure proper format with +1
    return `+1${cleanedUpPhoneNumber.slice(-10)}`;
  }
};

export const validatePhoneWithCountryCode = (phoneNumber: string): boolean => {
  // No value case
  if (!phoneNumber || phoneNumber.trim() === '') return false;
  // Exactly 10 digits
  if (/^\d{10}$/.test(phoneNumber)) {
    return true;
  }
  // Exactly +1 followed by 10 digits
  if (/^\+1\d{10}$/.test(phoneNumber)) {
    return true;
  }
  // Any other input format is invalid
  return false;
};
